import { render, staticRenderFns } from "./CustomProducts.vue?vue&type=template&id=4fc8b95f&"
import script from "./CustomProducts.vue?vue&type=script&lang=js&"
export * from "./CustomProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports